import { useQuery } from 'react-query';

import { getConfigUseCases } from '@onboarding/composition';

/**
 * Fetches existing service area names for the current store.
 * Used to prevent duplicate area names during wizard step 2.
 *
 * @returns Query result with existing area names as a Set for O(1) lookups
 */
export const useExistingAreaNames = () => {
  const { fetchExistingAreaNames } = getConfigUseCases();

  const { data: existingAreaNames = [] } = useQuery({
    queryKey: ['onboarding', 'existingAreaNames'],
    queryFn: () => fetchExistingAreaNames.execute(),
    staleTime: 30_000,
  });

  return new Set(existingAreaNames.map((name) => name.trim().toLowerCase()));
};
